<div class="admin-navigation">
    <ul class="admin-navigation__list">
        <li :class="{'admin-navigation__list__item': true, 'admin-navigation__list__item--active': adminRoutes.home.isActive}">
            <router-link protect :to="adminRoutes.home.route" class="admin-navigation__list__item__link">
                <span class="admin-navigation__list__item__icon">
                    <vl-icon icon="places-home" mod-large />
                </span>
            </router-link>
        </li>
        <li :class="{'admin-navigation__list__item': true, 'admin-navigation__list__item--active': adminRoutes.sessions.isActive}">
            <router-link protect :to="adminRoutes.sessions.route" class="admin-navigation__list__item__link">
                Sessions
            </router-link>
        </li>
        <li :class="{'admin-navigation__list__item': true, 'admin-navigation__list__item--active': adminRoutes.actors.isActive}">
            <router-link protect :to="adminRoutes.actors.route" class="admin-navigation__list__item__link">
                Actoren
            </router-link>
        </li>
        <li :class="{'admin-navigation__list__item': true, 'admin-navigation__list__item--active': adminRoutes.invoices.isActive}">
            <router-link protect :to="adminRoutes.invoices.route" class="admin-navigation__list__item__link">
                Facturatie
            </router-link>
        </li>
<!--        <li :class="{'admin-navigation__list__item': true, 'admin-navigation__list__item&#45;&#45;active': adminRoutes.auditLog.isActive}">-->
<!--            <router-link protect :to="adminRoutes.auditLog.route" class="admin-navigation__list__item__link">-->
<!--                Auditlog-->
<!--            </router-link>-->
<!--        </li>-->
        <li :class="{'admin-navigation__list__item': true, 'admin-navigation__list__item--active': adminRoutes.settings.isActive}">
            <router-link protect :to="adminRoutes.settings.route" class="admin-navigation__list__item__link">
                Instellingen
            </router-link>
        </li>
        <li :class="{'admin-navigation__list__item': true, 'admin-navigation__list__item--active': adminRoutes.account.isActive}">
            <router-link protect :to="adminRoutes.account.route" class="admin-navigation__list__item__link">
                Athumi account
            </router-link>
        </li>
    </ul>
</div>